import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Simple error boundary with retry for Beachvision pages.
 */
export class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 text-center">
          <AlertTriangle className="h-12 w-12 text-beachvision-coral mb-4" aria-hidden />
          <h2 className="text-white font-bold text-lg mb-2">Something went wrong</h2>
          <p className="text-beachvision-muted text-sm mb-6">{this.state.error.message}</p>
          <button
            type="button"
            className="bg-beachvision-coral text-white rounded-xl px-6 py-3 font-bold"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
